/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Automix_Fixed_Gain_SuffixInputs */

const en_audio_description_export_automix_fixed_gain_suffix = /** @type {(inputs: Audio_Description_Export_Automix_Fixed_Gain_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(Fixed Gain)`)
};

const fr_audio_description_export_automix_fixed_gain_suffix = /** @type {(inputs: Audio_Description_Export_Automix_Fixed_Gain_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(Gain fixe)`)
};

const de_audio_description_export_automix_fixed_gain_suffix = /** @type {(inputs: Audio_Description_Export_Automix_Fixed_Gain_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(Fester Gewinn)`)
};

const it_audio_description_export_automix_fixed_gain_suffix = /** @type {(inputs: Audio_Description_Export_Automix_Fixed_Gain_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(Guadagno fisso)`)
};

const ru_audio_description_export_automix_fixed_gain_suffix = /** @type {(inputs: Audio_Description_Export_Automix_Fixed_Gain_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(Фиксированный коэффициент усиления)`)
};

const es_audio_description_export_automix_fixed_gain_suffix = /** @type {(inputs: Audio_Description_Export_Automix_Fixed_Gain_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(Ganancia fija)`)
};

const zh_cn2_audio_description_export_automix_fixed_gain_suffix = /** @type {(inputs: Audio_Description_Export_Automix_Fixed_Gain_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`（固定收益）`)
};

const ja_audio_description_export_automix_fixed_gain_suffix = /** @type {(inputs: Audio_Description_Export_Automix_Fixed_Gain_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`（固定ゲイン）`)
};

const hi_audio_description_export_automix_fixed_gain_suffix = /** @type {(inputs: Audio_Description_Export_Automix_Fixed_Gain_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(निश्चित लाभ)`)
};

const pt_pt2_audio_description_export_automix_fixed_gain_suffix = /** @type {(inputs: Audio_Description_Export_Automix_Fixed_Gain_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(Ganho Fixo)`)
};

/**
* | output |
* | --- |
* | "(Fixed Gain)" |
*
* @param {Audio_Description_Export_Automix_Fixed_Gain_SuffixInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_automix_fixed_gain_suffix = /** @type {((inputs?: Audio_Description_Export_Automix_Fixed_Gain_SuffixInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Automix_Fixed_Gain_SuffixInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_automix_fixed_gain_suffix(inputs)
	if (locale === "de") return de_audio_description_export_automix_fixed_gain_suffix(inputs)
	if (locale === "it") return it_audio_description_export_automix_fixed_gain_suffix(inputs)
	if (locale === "ru") return ru_audio_description_export_automix_fixed_gain_suffix(inputs)
	if (locale === "es") return es_audio_description_export_automix_fixed_gain_suffix(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_automix_fixed_gain_suffix(inputs)
	if (locale === "ja") return ja_audio_description_export_automix_fixed_gain_suffix(inputs)
	if (locale === "hi") return hi_audio_description_export_automix_fixed_gain_suffix(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_automix_fixed_gain_suffix(inputs)
	return en_audio_description_export_automix_fixed_gain_suffix(inputs)
});